import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {ListItemType} from 'hiya-common/src/reducers/commonTypes'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export async function get_lucky_bonus_codepage() {
  const res = await http.post(
    '/live/ground/ly_b_codepage',
    window.store.getState().env.deviceinfo,
    {
      store: window?.store,
    }
  )
  return res.data.data
}
export async function get_lucky_bonus_result(airdrop_round_no: string) {
  const res = await http.post(
    '/live/ground/ly_b_result',
    {
      ...window.store.getState().env.deviceinfo,
      airdrop_round_no,
    },
    {
      store: window?.store,
    }
  )
  return res.data.data
}
export async function get_lucky_bonus_airdrop_records() {
  const res = await http.post(
    '/live/ground/ly_b_airdrop_records',
    window.store.getState().env.deviceinfo,
    {
      store: window?.store,
    }
  )
  return res.data.data
}
export async function get_lucky_bonus_winner_records() {
  const res = await http.post(
    '/live/ground/ly_b_winner_records',
    window.store.getState().env.deviceinfo,
    {
      store: window?.store,
    }
  )
  return res.data.data
}
export async function get_lucky_bonus_open_box(open_count) {
  const res = await http.post(
    '/live/ground/ly_b_open_box',
    {
      ...window.store.getState().env.deviceinfo,
      open_count,
    },
    {
      store: window?.store,
      xcErrorToast: true,
    }
  )
  return res.data.data
}
export async function get_lucky_bonus_rewardpage() {
  const res = await http.post(
    '/live/ground/ly_b_rewardpage',
    window.store.getState().env.deviceinfo,
    {
      store: window?.store,
    }
  )
  return res.data.data
}
// 获取往期号码牌最多的借口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=148319427
export async function lucky_bonus_ranking_records() {
  const res = await http.post(
    '/live/ground/ly_b_ranking_records',
    window.store.getState().env.deviceinfo,
    {
      store: window?.store,
    }
  )
  return res.data.data
}

export const lucky_bonus_homepage = createAsyncThunk(
  'lucky_bonus_homepage',
  async (arg, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/ground/ly_b_homepage',
      deviceinfo,
      {
        xcErrorToast: true,
        store,
      }
    )
    return resp.data.data
  }
)
// 修改store中的total_jackpot
export const lucky_bonus_rewardpage = createAsyncThunk(
  'lucky_bonus_rewardpage',
  async (arg, store: any) => {
    const {deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/ground/ly_b_rewardpage',
      deviceinfo,
      {
        xcErrorToast: true,
        store,
      }
    )
    return resp.data.data
  }
)

export enum FomoStatusEnum {
  notStarted = 0, // 未开始
  inProgress = 1, // 进行中
  paused = 2, // 暂停
  ended = 3, // 结束
}
interface InitialStateType {
  boxCount: number | string // 宝箱数量-用于数量更新
  fomoGuideShow: boolean // 新手引导
  fomoProcessAmising: boolean // 进度条动画
  addTime: number // 加时

  enable?: boolean // 活动上下线
  round_no?: string // 活动轮次-用于本次活动期间新手引导判断
  leader_member?: {
    // 领先者信息
    id: number
    zy_id: string
    name: string
    avatar: string
  }
  crazy_start_time?: number // 判断疯狂模式
  leader_num?: number // 领先者号码
  countdown?: number // 倒计时
  status?: FomoStatusEnum // 活动状态
  jackpot?: number // 大奖奖池
  total_jackpot?: number // 总奖池
  owner?: {
    // 用户自己数据
    last_num: number // 最新号码
    num_count: number // 号码数量
    dividend_coin: number // 预期分红奖励
    airdrop_rank: number // 空投排名
    airdrop_coin: number // 预期空投奖励
  }
  task?: {
    // 任务数据
    current: number // 当前值
    id: number // id
    target: number // 目标值
    box_count: number // 宝箱数量
    complete_count: number // 任务完成次数
  }
  tasks?: Array<{
    id: number // id
    coin: number // 目标值
  }>
  config?: {
    init_time: number // 活动初始时长 单位s
    max_time: number // 倒计时时长上限 单位s
    num_inc_time: number // 普通模式抽奖号码增加时长 单位s
    open_reward_time: number // 开奖时间阈值 单位s
    start_time: number // 活动开始时间戳
    day_start_time: string
    day_end_time: string
  }
  activity_start?: string // 活动开始时间
  isRouter?: boolean // 是否是fomo页面
}

const initialState: InitialStateType = {
  addTime: 0,
  boxCount: 0,
  fomoGuideShow: true,
  fomoProcessAmising: false,
}

export const GameFomoSlice = createSlice({
  name: 'Fomo',
  initialState,
  reducers: {
    updateFomo: (state, action: PayloadAction<any>) => {
      Object.assign(state, {
        ...state,
        jackpot: action.payload?.big_pool || state?.jackpot,
        ...action.payload,
      })
    },
    setFomoPage: (state, action: PayloadAction<any>) => {
      Object.assign(state, {
        isRouter: true,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(lucky_bonus_homepage.fulfilled, (state, action) => {
      Object.assign(state, {
        ...action.payload,
      })
    })
    builder.addCase(lucky_bonus_rewardpage.fulfilled, (state, action) => {
      const {total_jackpot} = action.payload
      Object.assign(state, {
        total_jackpot,
        ...state,
      })
    })
  },
})
export function useFomo() {
  return useSelector((store) => store.Fomo)
}
export default GameFomoSlice.reducer
export const GameFomoActions = GameFomoSlice.actions
